<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { ContractRestructuringActionType } from '../../../../../Constants/ContractRestructuringActionType.ts'
import type { ContractRestructuringAction } from '../../../../../Types/restructuring'
import OutstandingRepurchaseActionSummary from './OutstandingRepurchaseActionSummary.vue'

const props = defineProps<{
  action: ContractRestructuringAction
}>()

const { t } = useI18n()

const label = computed(() => t(`contract.restructuring.types.${props.action.actionType}.label`))

const summaryComponent = computed(() => {
  switch (props.action.actionType) {
    case ContractRestructuringActionType.OUTSTANDING_REPURCHASE:
      return OutstandingRepurchaseActionSummary

    default:
      return 'div'
  }
})
</script>

<template>
  <div>
    <h6 class="text-dark" data-test="contract-restructuring-action-summary-title">
      {{ label }}
    </h6>
  </div>

  <Component :is="summaryComponent" :action="action" />
</template>
